import { Classes, FormGroup } from "@blueprintjs/core";

import TokenSession from "core/util/session/TokenSession";
import {Institution} from "core/util/session/TokenUser";
import { ConditionTypeRegistry } from "../ConditionTypeRegistry";
import { IConditionType } from "../IConditionType";
import CheckBoxWidget from "common/form/widgets/CheckBoxWidget";


interface IInstitutesCondition {
	isInstitutionUser: boolean; 
}

const InstitutionsConditionType: IConditionType<IInstitutesCondition> = {
	type: "institutions",
	label: "User has Institution(s)",
	icon: "person",
	evaluate: ({isInstitutionUser}) => {
		
		let institutions:Institution[] = TokenSession.getUserInstitutions();
		let userHasInstitution:boolean = institutions && institutions.length>0;
		return userHasInstitution===isInstitutionUser
	},
	renderField: (value, onChange) => (
		<div>
			<FormGroup label="User has Insitituion(s)">
				<CheckBoxWidget
					onChange={(bool) => onChange({isInstitutionUser:bool})}
					value={value.isInstitutionUser}
				/>
			</FormGroup>
		</div>
	),
	renderPreview: (value) => (
		<div>
			<div className={Classes.TEXT_MUTED}> Condition Evaluates to {new String(InstitutionsConditionType.evaluate(value,undefined))}. Current User has 
				{TokenSession.getUserInstitutions() && TokenSession.getUserInstitutions().length > 0 ? 
				" Institutions: "+TokenSession.getUserInstitutions().map(i=>i.name).join(", "): " no Institutition."}
			</div>
		</div>
	),
	getInitialValue: () => ({isInstitutionUser:true})
};

export default ConditionTypeRegistry.register(InstitutionsConditionType);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/InstitutionsCondition.reg.tsx